import React, { useEffect, useRef } from 'react';
import { Input, FormControl, InputAdornment } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import faSearch from '../../assets/img/search.svg';
import Card from '@material-ui/core/Card';
import styled from 'styled-components';
import consts from '../../utils/consts';
import { getResponseAPIData, getPostResponseAPIData } from '../../services/apiService';
import { pushAPIData, pushSearchChipArray, resetSearchData } from '../../slices/customQuerySlice';
import { pushTablePageCount, pushTableRowCount, pushTableTotalCount, pushSearchLoader } from '../../slices/customQueryBodySlice';
import { setSearchString } from '../../slices/customQuerySlice';
import { pushPostApiResponse, pushgetApiResponse } from '../../slices/customQueryHeaderSlice';
export const SearchTextCard = styled(Card)`
  border-top: 1px rgba(0, 0, 0, 0.125);
  border-radius: none;
  border-bottom: 1px rgba(0, 0, 0, 0.125);
  padding: 3px;
  background-color: rgba(228, 230, 236, 0.4) !important;
  box-shadow: none !important;
  height: 40px;
  width: 725px;
`;
export const SearchIcon = styled(InputAdornment)`
  margin: 4px;
`;
export const StyledFormControl = styled(FormControl)`
  width: 720px;
`;

const CardHeader = () => {
  let {
    baseUrlquery,
    requestbody,
    paginationString,
    baseUrl,
    paginationStringQuery
  } = consts;
  let timerId = useRef(null);
  const searchData = useSelector(state => state.customQueryHeader.search);
  const dataItem = useSelector(state => state.customQuery.dataItem);
  const searchString = useSelector(state => state.customQuery.searchedText);
  useEffect(() => {
    if (searchData && searchData[0]) {
      dispatch(pushTableTotalCount(searchData[0].headers.totalcount));
      let datafetch = [];
      let dataItemList = dataItem.recordType;
      datafetch.push({
        data: searchData[0].data && searchData[0].data.queryData,
        type: dataItemList
      });
      dispatch(pushAPIData(datafetch));
      dispatch(pushSearchChipArray(dataItem));
      dispatch(pushSearchLoader(false));
    }

    return () => {
      clearTimeout(timerId.current);
    };
  }, [searchData]);
  const dispatch = useDispatch();

  const onChangeHandler = event => {
    const {
      value
    } = event.target;
    let searchText = event.target.value;
    dispatch(setSearchString(searchText));
    clearTimeout(timerId.current);
    timerId.current = setTimeout(() => {
      let dataItemList = dataItem.recordType;
      let localBaseUrl = baseUrl;
      let paginationQueryString = paginationString + 1;
      dispatch(pushSearchLoader(true));
      let searchdata = {
        data: '',
        type: 'search'
      };
      dispatch(pushgetApiResponse(searchdata));
      let data = {
        data: '',
        type: 'postCustomQuery'
      };
      dispatch(pushgetApiResponse(data));
      let savedata = {
        data: '',
        type: 'postCustomQuery'
      };
      dispatch(pushPostApiResponse(savedata));
      dispatch(resetSearchData());
      dispatch(pushTablePageCount(''));
      dispatch(pushTableRowCount(''));
      dispatch(pushTableTotalCount(''));

      if (value.length > 0) {
        let searchTextName = dataItem.keyName.replace(/\s+/g, '') === 'Application' ? 'ApplicationName' : dataItem.keyName.replace(/\s/g, '');
        let appurl = baseUrlquery + 'criteria?' + `key=${encodeURIComponent(value)}&name=${searchTextName}` + '&limit=10&offset=1';
        dispatch(getResponseAPIData([appurl], 'search'));
      } else {
        dispatch(pushSearchLoader(true));
        let urlEntityName = dataItemList === 'user accounts' ? 'useraccount' : dataItemList.substring(0, dataItemList.length - 1);
        let urls = localBaseUrl + urlEntityName.toLowerCase() + paginationQueryString;

        if (dataItemList === 'applications' || dataItemList === 'environments') {
          let appurl = baseUrlquery + dataItemList + paginationStringQuery;
          dispatch(getResponseAPIData([appurl], 'postCustomQuery'));
        } else {
          dispatch(getPostResponseAPIData([urls], requestbody, 'postCustomQuery'));
        }
      }
    }, 1000);
  };

  return /*#__PURE__*/React.createElement(SearchTextCard, null, /*#__PURE__*/React.createElement(StyledFormControl, null, /*#__PURE__*/React.createElement(Input, {
    disableUnderline: true,
    id: "input-with-icon-adornment",
    placeholder: "Search",
    startAdornment: /*#__PURE__*/React.createElement(SearchIcon, {
      position: "start"
    }, /*#__PURE__*/React.createElement("img", {
      src: faSearch
    })),
    value: searchString,
    onChange: onChangeHandler
  })));
};

export default CardHeader;